type QueryKey = readonly unknown[];

export interface EventRoute {
  /** Query keys для инвалидации при получении этого события */
  getQueryKeys: (payload: Record<string, unknown>) => QueryKey[];
}

class EventRouter {
  private routes = new Map<string, EventRoute>();

  register(eventType: string, route: EventRoute): void {
    this.routes.set(eventType, route);
  }

  getEventTypes(): string[] {
    return [...this.routes.keys()];
  }

  getQueryKeys(
    eventType: string,
    payload: Record<string, unknown>,
  ): QueryKey[] {
    return this.routes.get(eventType)?.getQueryKeys(payload) ?? [];
  }
}

export const eventRouter = new EventRouter();
